import { doc, onSnapshot, setDoc } from "firebase/firestore";
import { useEffect, useState } from "react";
import { db } from "./firebase";
import dayjs from "dayjs";
import { useAuth } from "./contexts/AuthContext";

const emptyChecklist = [
	{
		title: "Sjekket at sikkerhetssnoren står i ved toppstasjonen",
		checked: false,
	},
	{
		title: "Fjernet snø om nødvendig, slik at sikkerhetssnoren henger fritt (30-50cm)",
		checked: false,
	},

	{
		title: "Sjekket øvre nødstopp ved å trykke ned den røde soppen og trukket opp igjen",
		checked: false,
	},
	{
		title: "Sjekket at slepetraseen og på- og avstigningsplassen er forsvarlig preparert",
		checked: false,
	},
	{
		title: "Sjekket nedre nødstopp ved å trykke ned den røde soppen og trukket opp igjen",
		checked: false,
	},
	{
		title: "Ingen ulyd fra drivstasjonen ved oppstart",
		checked: false,
	},
	{
		title: "Kontrollert start og stoppfunksjon på tavle og mobil konsoll",
		checked: false,
	},
	{
		title: "Vakt(er) vet hva som skal gjøres ved personskader (se oppslag)",
		checked: false,
	},
	{
		title: "Sikkerhetsnor er funksjonstestet før oppstart",
		checked: false,
	},
	{
		title: "Alle skilt/polstringer og gjerder er oppsatt i H.H.T. arrangementplan (se oppslag)",
		checked: false,
	},
];

export const useChecklist = () => {
	const { profile } = useAuth();
	const [checklist, setChecklist] = useState<
		{ title: string; checked: boolean }[]
	>([]);
	const [hours, setHours] = useState<number | null>(null); // accumulated hour counter
	const [note, setNote] = useState<string>(""); // end roster note
	const [sendSms, setSendSms] = useState<boolean>(false); // request sending SMS to admins
	const [loading, setIsLoading] = useState(true);

	const allChecked = checklist.every((item) => item.checked);
	const todayString = dayjs().format("YYYY-MM-DD");

	useEffect(() => {
		if (loading) return; // Avoid saving before initial load
		const saveChecklist = async () => {
			const docRef = doc(db, "liftLog", todayString);
			await setDoc(
				docRef,
				{
					checklist,
					phoneNumber: profile?.phoneNumber,
					name: profile?.firstName,
					allChecked,
					hours: hours ?? null,
					note,
					sendSms,
				},
				{ merge: true }
			);
			console.log("Saved liftLog to db", {
				checklistLength: checklist.length,
				hours,
				sendSms,
			});
		};
		saveChecklist();
	}, [
		checklist,
		allChecked,
		hours,
		note,
		sendSms,
		profile?.phoneNumber,
		profile?.firstName,
		todayString,
		loading,
	]);

	useEffect(() => {
		const docRef = doc(db, "liftLog", todayString);
		const unsubscribe = onSnapshot(docRef, (docSnap) => {
			const data = docSnap.data();
			console.log("Got liftLog data:", data);
			if (data) {
				if (data.checklist?.length > 0) {
					setChecklist(data.checklist);
				} else if (checklist.length === 0) {
					setChecklist(emptyChecklist);
				}
				if (typeof data.hours === "number") setHours(data.hours);
				if (typeof data.note === "string") setNote(data.note);
				if (typeof data.sendSms === "boolean") setSendSms(data.sendSms);
			} else if (checklist.length === 0) {
				setChecklist(emptyChecklist);
			}
			setIsLoading(false);
		});
		return unsubscribe;
	}, [todayString, checklist.length]);

	return {
		items: checklist,
		allChecked,
		setChecklist,
		loading,
		hours,
		setHours,
		note,
		setNote,
		sendSms,
		setSendSms,
	};
};
